<template lang="html">

  <section class="test-devices">
    
    <v-card class="ma-5">
        <v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title class="headline">
                    ניהול מכשירי טסט
                </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action @click="add">
                <v-btn color="success">
                    <v-icon>mdi-plus</v-icon>
                    הוסף מכשיר
                </v-btn>
            </v-list-item-action>
        </v-list-item>

        <v-list-item v-for="device in testDevices">
            <v-list-item-icon>
                <v-icon>mdi-device</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-if="!device.edit">{{device.name}}</v-list-item-title>
            <v-list-item-title v-if="device.edit">
                <v-text-field label="שם המכשיר" v-model="device.name"></v-text-field>
            </v-list-item-title>
            <v-list-item-title v-if="device.edit">
                <v-text-field label="token" v-model="device.token"></v-text-field>
            </v-list-item-title>
            <v-list-item-action @click="device.edit = !device.edit; save(device)">
                <v-icon color="success" v-if="device.edit">mdi-content-save</v-icon>
                <v-icon color="success" v-if="!device.edit">mdi-pencil</v-icon>
            </v-list-item-action>
            <v-list-item-action>
                <v-icon color="error">mdi-delete</v-icon>
            </v-list-item-action>
        </v-list-item>

    </v-card>
  </section>

</template>

<script lang="js">

  export default  {
    name: 'test-devices',
    props: [],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
        add() {
            this.testDevices.push({
                edit: true
            })
        },
        save(device){
          !device.edit &&
          this.$store.dispatch('saveDevices',device)
        }
    },
    computed: {
      testDevices() {
        return this.$store.getters.testDevices
      }
    }
}


</script>

<style scoped lang="scss">
  .test-devices {

  }
</style>
